import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'

import FormContainer from './form-container'

class NotePaymentsNew extends Component {

  componentDidMount() {
    const { dispatch, __session, __nextOrno } = this.props
    dispatch(actions.reset('notePaymentState'))
    dispatch(actions.change('notePaymentState.sy', __session.get('sy')))
    dispatch(actions.change('notePaymentState.sem', __session.get('sem')))
    dispatch(actions.change('notePaymentState.refno', ''))
  }

  render() {
    const { onSearchForm } = this.props

    return (
      <FormContainer onSearchForm={onSearchForm} isNew />
    )
  }
}

NotePaymentsNew.propTypes = {
  __session: PropTypes.object,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __session: state.auth.get('session'),
  }
}

export default connect(mapStateToProps)(NotePaymentsNew)



// WEBPACK FOOTER //
// ./src/containers/NotePayments/new.js